import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { getLocaleFromPathname } from '../config/localeRoutes';

function LocaleSync() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const locale = getLocaleFromPathname(location.pathname);

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  return (
    <Helmet>
      <html lang={locale} />
    </Helmet>
  );
}

export default LocaleSync;
